import CreateRouteStack from "./createRouteStack";

let middlewareStack = [CreateRouteStack];

export function execute(middlewareIndex, to, from, next) {
    const middleware = middlewareStack[middlewareIndex];

    if (typeof middleware === 'function') {
        middleware(to, from, () => {
            execute(middlewareIndex + 1, to, from, next);
        });
    } else {
        next();
    }
}

export function run(to, from, next) {
    execute(0, to, from, next);
}

export default run;